import React, { useEffect, useState, useRef } from 'react';
import './style.scss';

const MainComponent = () => {
    const [visibleDiv, setVisibleDiv] = useState(0);
    const containerRef = useRef(null);

    const sections = [
        () =>
            <section className={`container-wrapper ${visibleDiv === 0 ? 'active' : ''}`} id="section1">
                <div className="img-container">
                    <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/masteriyo_setup-wizard.webp" alt="" />
                </div>
                <div className="main-container-wrapper">
                    <div className="heading-section">
                        <div className="section-item active">
                            <h3>Catalog</h3>
                        </div>
                        <div className="section-item">
                            <h3>Enquiry</h3>
                        </div>
                        <div className="section-item">
                            <h3>Quote</h3>
                        </div>
                        <div className="section-item">
                            <h3>Wholesale</h3>
                        </div>
                        <div className="section-item">
                            <h3>Role-Based Pricing</h3>
                        </div>
                    </div>
                    <p className="section-description">CatalogX's advanced catalog features transform your WooCommerce store into a dynamic product showcase. Customize visibility, pricing, and user interactions to create an engaging shopping experience that drives customer interest and boosts sales potential.</p>
                    <div className="flat-card-wrapper">
                        <article>
                            <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/Now-you-create-coupon-for-your-valuable-customer-6-1024x1024.png" alt="" />
                            <h4>Flexible Catalog Mode</h4>
                            <p>Enable catalog mode for your entire store or specific products, </p>
                        </article>
                        <article>
                            <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/Now-you-create-coupon-for-your-valuable-customer-6-1024x1024.png" alt="" />
                            <h4>Private Store Option</h4>
                            <p>Create an exclusive shopping experience by hiding prices and 'Add to Cart' buttons until users log in.</p>
                        </article>
                        <article>
                            <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/Now-you-create-coupon-for-your-valuable-customer-6-1024x1024.png" alt="" />
                            <h4>Customizable Button Display</h4>
                            <p>Choose to hide 'Add to Cart' buttons or display both 'Add to Cart'.</p>
                        </article>
                        <article>
                            <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/Now-you-create-coupon-for-your-valuable-customer-6-1024x1024.png" alt="" />
                            <h4>Flexible Product Showcase</h4>
                            <p>Showcase your entire product range without the pressure of.</p>
                        </article>
                    </div>
                </div>
            </section>,
        () =>
            <section className={`container-wrapper ${visibleDiv === 1 ? 'active' : ''}`} id="section2">
                <div className="img-container">
                    <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/masteriyo_setup-wizard.webp" alt="" />
                </div>
                <div className="main-container-wrapper">
                    <div className="heading-section">
                        <div className="section-item">
                            <h3>Catalog</h3>
                        </div>
                        <div className="section-item active">
                            <h3>Enquiry</h3>
                        </div>
                        <div className="section-item">
                            <h3>Quote</h3>
                        </div>
                        <div className="section-item">
                            <h3>Wholesale</h3>
                        </div>
                        <div className="section-item">
                            <h3>Role-Based Pricing</h3>
                        </div>
                    </div>
                    <p className="section-description">Turn Every Visit into an Opportunity: Where Curiosity Becomes Conversion. CatalogX Enquiry Mode transforms your store into a dynamic engagement hub, where every click, .</p>
                    <div className="flat-card-wrapper">
                        <article>
                            <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/Now-you-create-coupon-for-your-valuable-customer-6-1024x1024.png" alt="" />
                            <h4>Efficient Customer Response System</h4>
                            <p>With a centralized dashboard and quick-response templates, it boosts response </p>
                        </article>
                        <article>
                            <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/Now-you-create-coupon-for-your-valuable-customer-6-1024x1024.png" alt="" />
                            <h4>Custom Inquiry Forms Builder</h4>
                            <p>Create dynamic, product-specific inquiry forms to improve lead quality and.</p>
                        </article>
                        <article>
                            <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/Now-you-create-coupon-for-your-valuable-customer-6-1024x1024.png" alt="" />
                            <h4>Multi-Product Inquiry Cart</h4>
                            <p>Enhance customer inquiries with the Inquiry Cart, allowing multiple products to be</p>
                        </article>
                        <article>
                            <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/Now-you-create-coupon-for-your-valuable-customer-6-1024x1024.png" alt="" />
                            <h4>Out-of-Stock Inquiry Feature</h4>
                            <p>Turn inventory shortages into sales with the Out-of-Stock Inquiry Feature.</p>
                        </article>
                    </div>
                </div>
            </section>,
        () =>
            <section className={`container-wrapper ${visibleDiv === 2 ? 'active' : ''}`} id="section3">
                <div className="img-container">
                    <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/masteriyo_setup-wizard.webp" alt="" />
                </div>
                <div className="main-container-wrapper">
                    <div className="heading-section">
                        <div className="section-item">
                            <h3>Catalog</h3>
                        </div>
                        <div className="section-item">
                            <h3>Enquiry</h3>
                        </div>
                        <div className="section-item active">
                            <h3>Quote</h3>
                        </div>
                        <div className="section-item">
                            <h3>Wholesale</h3>
                        </div>
                        <div className="section-item">
                            <h3>Role-Based Pricing</h3>
                        </div>
                    </div>
                    <p className="section-description">Transform your WooCommerce store into a quote-generating powerhouse. Streamline complex sales, engage high-value customers, and boost conversions with our advanced quoting system.</p>
                    <div className="flat-card-wrapper">
                        <article>
                            <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/Now-you-create-coupon-for-your-valuable-customer-6-1024x1024.png" alt="" />
                            <h4>Multi-Product Quote Requests</h4>
                            <p>Allow customers to add multiple products to a single quote request, simplifies.</p>
                        </article>
                        <article>
                            <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/Now-you-create-coupon-for-your-valuable-customer-6-1024x1024.png" alt="" />
                            <h4>Automated Quote Follow-ups</h4>
                            <p>Set up intelligent, timed follow-up emails for open quote requests.</p>
                        </article>
                        <article>
                            <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/Now-you-create-coupon-for-your-valuable-customer-6-1024x1024.png" alt="" />
                            <h4>Quick-Quote Templates</h4>
                            <p>Use predefined templates to quickly generate professional, personalized.</p>
                        </article>
                        <article>
                            <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/Now-you-create-coupon-for-your-valuable-customer-6-1024x1024.png" alt="" />
                            <h4>Customer Quote Management Dashboard</h4>
                            <p>Customers can view, manage, and accept quotes directly from their accounts.</p>
                        </article>
                    </div>
                </div>
            </section>,
        () =>
            <section className={`container-wrapper ${visibleDiv === 3 ? 'active' : ''}`} id="section4">
                <div className="img-container">
                    <img src="https://cdn.shortpixel.ai/spai/w_713+q_lossless+ret_img+to_webp/wpastra.com/wp-content/uploads/2023/12/high-converting-img.png" alt="" />
                </div>
                <div className="main-container-wrapper">
                    <div className="heading-section">
                        <div className="section-item">
                            <h3>Catalog</h3>
                        </div>
                        <div className="section-item">
                            <h3>Enquiry</h3>
                        </div>
                        <div className="section-item">
                            <h3>Quote</h3>
                        </div>
                        <div className="section-item active">
                            <h3>Wholesale</h3>
                        </div>
                        <div className="section-item">
                            <h3>Role-Based Pricing</h3>
                        </div>
                    </div>
                    <p className="section-description">Unlock a new realm of B2B efficiency and savings with CatalogX Wholesale Mode. Empower your store to cater specifically to bulk buyers, offering tiered pricing, custom discounts.</p>
                    <div className="flat-card-wrapper">
                        <article>
                            <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/Now-you-create-coupon-for-your-valuable-customer-6-1024x1024.png" alt="" />
                            <h4>Tiered Pricing Structures</h4>
                            <p>Implement tiered pricing structures to reward bulk purchases, encouraging.</p>
                        </article>
                        <article>
                            <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/Now-you-create-coupon-for-your-valuable-customer-6-1024x1024.png" alt="" />
                            <h4>Minimum Order Quantities</h4>
                            <p>Set minimum order quantities for wholesale customers, ensuring efficient.</p>
                        </article>
                        <article>
                            <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/Now-you-create-coupon-for-your-valuable-customer-6-1024x1024.png" alt="" />
                            <h4>Wholesale Customer Registration</h4>
                            <p>Enable wholesale-specific registration to separate B2B and B2C sales channels.</p>
                        </article>
                        <article>
                            <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/Now-you-create-coupon-for-your-valuable-customer-6-1024x1024.png" alt="" />
                            <h4>Custom Discount Rules</h4>
                            <p>Create custom discount rules based on order size, product categories.</p>
                        </article>
                    </div>
                </div>
            </section>,
        () =>
            <section className={`container-wrapper ${visibleDiv === 4 ? 'active' : ''}`} id="section5">
                <div className="img-container">
                    <img src="https://cdn.shortpixel.ai/spai/w_559+q_lossless+ret_img+to_webp/wpastra.com/wp-content/uploads/2018/01/checkout-1.png" alt="" />
                </div>
                <div className="main-container-wrapper">
                    <div className="heading-section">
                        <div className="section-item">
                            <h3>Catalog</h3>
                        </div>
                        <div className="section-item">
                            <h3>Enquiry</h3>
                        </div>
                        <div className="section-item">
                            <h3>Quote</h3>
                        </div>
                        <div className="section-item">
                            <h3>Wholesale</h3>
                        </div>
                        <div className="section-item active">
                            <h3>Role-Based Pricing</h3>
                        </div>
                    </div>
                    <p className="section-description">Maximize Revenue with Tailored Pricing Strategies: Precision Pricing for Every Customer. Transform your WooCommerce store into a dynamic marketplace with CatalogX Role-Based Pricing Mode</p>
                    <div className="flat-card-wrapper">
                        <article>
                            <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/Now-you-create-coupon-for-your-valuable-customer-6-1024x1024.png" alt="" />
                            <h4>Dynamic Pricing Rules</h4>
                            <p>Implement dynamic pricing rules that adjust automatically based on customer roles, purchase</p>
                        </article>
                        <article>
                            <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/Now-you-create-coupon-for-your-valuable-customer-6-1024x1024.png" alt="" />
                            <h4>Custom Pricing Tiers</h4>
                            <p>Create multiple pricing tiers for different customer groups, such as wholesale.</p>
                        </article>
                        <article>
                            <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/Now-you-create-coupon-for-your-valuable-customer-6-1024x1024.png" alt="" />
                            <h4>Role-Based Discounts</h4>
                            <p>Offer exclusive discounts based on user roles, rewarding loyal customers and.</p>
                        </article>
                        <article>
                            <img src="https://dualstg.wpengine.com/wp-content/uploads/2024/06/Now-you-create-coupon-for-your-valuable-customer-6-1024x1024.png" alt="" />
                            <h4>Customer-Specific Pricing</h4>
                            <p>Set up personalized pricing for individual customers or groups, ensuring the best.</p>
                        </article>
                    </div>
                </div>
            </section>
    ];

    const handleScroll = () => {
        const containerTop = containerRef.current.getBoundingClientRect().top;
        if (containerTop <= 0) {
            const divIndex = Math.floor(Math.abs(containerTop) / 850);
            if (divIndex >= 0 && divIndex < sections.length) {
                setVisibleDiv(divIndex);
            }
        }
    };

    console.log(visibleDiv);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            <div className="fixed-container">
                <h2 className="main-section-heading">Unleash Your WooCommerce Superpowers</h2>
                <p className="main-section-subHeading">CatalogX: <span className="highlight">Where Flexibility Meets Profitability</span></p>
                <main className="main-site-wrapper" ref={containerRef} id='main-wrapper-section'>
                    <div ref={containerRef} className="main-wrapper">
                        {sections.map((Section, index) => (
                            <Section key={index} />
                        ))}
                    </div>
                </main>
            </div>
        </>
    );
};

export default MainComponent;
